export const COLUMN1 = [
  "DT - Deciduous tooth",
  "DTC - Dentigerous cyst",
  "CWD - Crowding",
  "GE - Gingival enlargement",
  "GH - Gingival hyperplasia",
  "GM - Gingival mass"
];

export const COLUMN2 = [
  "MN/FX - Mandibular fracture",
  "MX/FX - Maxillary fracture",
  "OAF - Oroantral fistula",
  "ONF - Oronasal fistula",
  "OM - Oral mass",
  "ROT - Rotated tooth"
];

export const COLUMN3 = [
  "RR - Internal resorption",
  "RRT - Retained root tip",
  "SI - Intrinsic staining",
  "T/NV - Non-vital tooth",
  "T/PE - Pulp exposure",
  "T/SN - Supernumerary tooth"
];
